// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favourite-button {
    align-items: center;
    background: transparent;
    border: none;
    border-radius: 999px;
    color: #111111;
    cursor: pointer;
    display: inline-flex;
    height: 40px;
    justify-content: center;
    padding: 0;
    transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;
    width: 40px;
}

.favourite-button:hover {
    background: rgba(17, 17, 17, 0.05);
    transform: scale(1.04);
}

.favourite-button__icon {
    fill: transparent;
    stroke-width: 2px;
    transition: fill 0.2s ease, stroke 0.2s ease;
}

.favourite-button.is-active .favourite-button__icon {
    fill: #111111;
}
`, "",{"version":3,"sources":["webpack://./src/components/FavouriteButton/FavouriteButton.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,4EAA4E;IAC5E,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".favourite-button {\n    align-items: center;\n    background: transparent;\n    border: none;\n    border-radius: 999px;\n    color: #111111;\n    cursor: pointer;\n    display: inline-flex;\n    height: 40px;\n    justify-content: center;\n    padding: 0;\n    transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;\n    width: 40px;\n}\n\n.favourite-button:hover {\n    background: rgba(17, 17, 17, 0.05);\n    transform: scale(1.04);\n}\n\n.favourite-button__icon {\n    fill: transparent;\n    stroke-width: 2px;\n    transition: fill 0.2s ease, stroke 0.2s ease;\n}\n\n.favourite-button.is-active .favourite-button__icon {\n    fill: #111111;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
